import { render, staticRenderFns } from "./BlackGradationButton.vue?vue&type=template&id=5c76cda2&scoped=true&"
import script from "./BlackGradationButton.vue?vue&type=script&lang=js&"
export * from "./BlackGradationButton.vue?vue&type=script&lang=js&"
import style0 from "./BlackGradationButton.vue?vue&type=style&index=0&id=5c76cda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76cda2",
  null
  
)

export default component.exports